import React, { useMemo } from 'react';

import { isUserNeedKyc, needsBankAccounts, useApplicationState } from '@atlas/core';
import { Button, Icon, Label } from '@atlas/ui';

import history from 'components/Layout/history';

export const VerificationBlock = ({ onClose }) => {
  const { account, bankAccounts } = useApplicationState();

  const modalText = useMemo(() => {
    if (isUserNeedKyc(account)) {
      return {
        btnText: 'go_to_kyc',
        description: 'kyc_verification_description',
        icon: 'error-outline',
        iconClass: 'kyc-verification-popup-icon',
        link: '/account/verification',
        title: 'kyc_popup_title',
      };
    }

    if (needsBankAccounts(bankAccounts)) {
      return {
        btnText: 'kyc_popup_register_bank_account_button',
        description: 'kyc_popup_register_bank_account_descriprion',
        icon: 'security-legitimuz',
        iconClass: 'kyc-verification-popup-icon-add-bank-account',
        link: '/account/profile/account-numbers',
        title: 'kyc_popup_register_bank_account_title',
      };
    }

    return { link: '/' };
  }, [account, bankAccounts]);

  const handleRedirectToAccount = () => {
    history.push(modalText?.link);
    onClose();
  };

  return (
    <div className={'one-step-deposit-kyc-verifcation'}>
      <div className="kyc-verification-block deposit">
        <div className="kyc-popup">
          <Icon className={modalText?.iconClass} height={48} name={modalText?.icon} width={48} />
          <Label className="kyc-verification-popup-title" message={modalText?.title} />
          <Label className="kyc-verification-popup-description" message={modalText?.description} />
          <Button
            className="kyc-verification-popup-button"
            onClick={handleRedirectToAccount}
            size="huge"
          >
            <Label message={modalText?.btnText} />
          </Button>
        </div>
      </div>
    </div>
  );
};
